import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "./components/Header";

function ProductPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);

  // Atualizar URL no Chatwoot quando a página carrega
  useEffect(() => {
    if (window.updateChatwootURL) {
      window.updateChatwootURL();
    }
  }, [slug]);

  // Simular dados de produto baseado no slug
  useEffect(() => {
    // Extrair informações do slug para criar dados de produto
    const productName = slug.replace(/-/g, " ");
    const words = productName.split(" ");

    // Simular dados de produto baseado no slug
    const mockProduct = {
      id: Math.floor(Math.random() * 1000),
      name: words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      slug: slug,
      price: Math.floor(Math.random() * 2000) + 100,
      originalPrice: Math.floor(Math.random() * 2500) + 150,
      category: getCategoryFromSlug(slug),
      rating: (Math.random() * 2 + 3).toFixed(1), // Entre 3.0 e 5.0
      reviews: Math.floor(Math.random() * 500) + 50,
      image: getEmojiFromCategory(getCategoryFromSlug(slug)),
      discount: Math.floor(Math.random() * 30) + 5,
      description: `Descubra o ${words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(
          " "
        )} - uma excelente escolha para as suas necessidades. Este produto combina qualidade, performance e design moderno.`,
      features: [
        "Garantia de 2 anos",
        "Entrega gratuita",
        "Suporte técnico 24/7",
        "Devolução em 30 dias",
      ],
      specifications: {
        Marca: words[0]
          ? words[0].charAt(0).toUpperCase() + words[0].slice(1)
          : "Genérica",
        Modelo: slug,
        Categoria: getCategoryFromSlug(slug),
        Disponibilidade: "Em stock",
      },
    };

    setProduct(mockProduct);
  }, [slug]);

  const getCategoryFromSlug = (slug) => {
    const slugLower = slug.toLowerCase();
    if (
      slugLower.includes("pc") ||
      slugLower.includes("laptop") ||
      slugLower.includes("portatil")
    ) {
      return "Computadores";
    } else if (
      slugLower.includes("iphone") ||
      slugLower.includes("samsung") ||
      slugLower.includes("smartphone")
    ) {
      return "Smartphones";
    } else if (slugLower.includes("tv") || slugLower.includes("televisao")) {
      return "TVs";
    } else if (
      slugLower.includes("airpods") ||
      slugLower.includes("fone") ||
      slugLower.includes("audio")
    ) {
      return "Áudio";
    } else if (slugLower.includes("ipad") || slugLower.includes("tablet")) {
      return "Tablets";
    } else if (
      slugLower.includes("camera") ||
      slugLower.includes("canon") ||
      slugLower.includes("foto")
    ) {
      return "Fotografia";
    } else if (
      slugLower.includes("playstation") ||
      slugLower.includes("xbox") ||
      slugLower.includes("gaming")
    ) {
      return "Gaming";
    } else if (
      slugLower.includes("nest") ||
      slugLower.includes("smart") ||
      slugLower.includes("casa")
    ) {
      return "Casa Inteligente";
    }
    return "Eletrónicos";
  };

  const getEmojiFromCategory = (category) => {
    const emojiMap = {
      Computadores: "💻",
      Smartphones: "📱",
      TVs: "📺",
      Áudio: "🎧",
      Tablets: "📱",
      Fotografia: "📷",
      Gaming: "🎮",
      "Casa Inteligente": "🏠",
      Eletrónicos: "⚡",
    };
    return emojiMap[category] || "⚡";
  };

  const addToCart = () => {
    // Simular adição ao carrinho
    alert(`${product.name} adicionado ao carrinho!`);
  };

  if (!product) {
    return <div className="loading">A carregar produto...</div>;
  }

  return (
    <div className="product-page">
      <Header />

      {/* Breadcrumb */}
      <div className="breadcrumb">
        <div className="container">
          <nav>
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                navigate("/");
              }}
            >
              Início
            </a>
            <span> / </span>
            <a href={`#${product.category.toLowerCase()}`}>
              {product.category}
            </a>
            <span> / </span>
            <span>{product.name}</span>
          </nav>
        </div>
      </div>

      {/* Product Details */}
      <div className="product-details">
        <div className="container">
          <div className="product-layout">
            <div className="product-image-section">
              <div className="product-main-image">
                <span className="product-emoji-large">{product.image}</span>
                {product.discount > 0 && (
                  <div className="discount-badge-large">
                    -{product.discount}%
                  </div>
                )}
              </div>
            </div>

            <div className="product-info-section">
              <div className="product-header">
                <h1>{product.name}</h1>
                <div className="product-category">{product.category}</div>
                <div className="product-rating">
                  <span className="stars">
                    {"⭐".repeat(Math.floor(parseFloat(product.rating)))}
                  </span>
                  <span className="rating-text">
                    {product.rating} ({product.reviews} avaliações)
                  </span>
                </div>
              </div>

              <div className="product-price-section">
                <div className="current-price">{product.price.toFixed(2)}€</div>
                {product.originalPrice > product.price && (
                  <div className="original-price">
                    {product.originalPrice.toFixed(2)}€
                  </div>
                )}
                {product.discount > 0 && (
                  <div className="savings">
                    Poupa{" "}
                    {(
                      ((product.originalPrice - product.price) /
                        product.originalPrice) *
                      100
                    ).toFixed(0)}
                    %
                  </div>
                )}
              </div>

              <div className="product-description">
                <p>{product.description}</p>
              </div>

              <div className="product-features">
                <h3>Características:</h3>
                <ul>
                  {product.features.map((feature, index) => (
                    <li key={index}>✓ {feature}</li>
                  ))}
                </ul>
              </div>

              <div className="product-actions">
                <button className="add-to-cart-btn-large" onClick={addToCart}>
                  Adicionar ao Carrinho
                </button>
                <button className="buy-now-btn">Comprar Agora</button>
              </div>
            </div>
          </div>

          {/* Product Specifications */}
          <div className="product-specifications">
            <h3>Especificações Técnicas</h3>
            <div className="specs-grid">
              {Object.entries(product.specifications).map(([key, value]) => (
                <div key={key} className="spec-item">
                  <span className="spec-label">{key}:</span>
                  <span className="spec-value">{value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Footer (reutilizar o mesmo footer) */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>Kodly</h4>
              <p>A sua loja de confiança em tecnologia desde 2015.</p>
              <div className="social-links">
                <a href="#facebook">📘</a>
                <a href="#instagram">📷</a>
                <a href="#twitter">🐦</a>
                <a href="#youtube">📺</a>
              </div>
            </div>

            <div className="footer-section">
              <h4>Ajuda</h4>
              <ul>
                <li>
                  <a href="#contact">Contactos</a>
                </li>
                <li>
                  <a href="#shipping">Envio e Entrega</a>
                </li>
                <li>
                  <a href="#returns">Devoluções</a>
                </li>
                <li>
                  <a href="#warranty">Garantias</a>
                </li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Empresa</h4>
              <ul>
                <li>
                  <a href="#about">Sobre Nós</a>
                </li>
                <li>
                  <a href="#careers">Carreiras</a>
                </li>
                <li>
                  <a href="#stores">Lojas</a>
                </li>
                <li>
                  <a href="#press">Imprensa</a>
                </li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Legal</h4>
              <ul>
                <li>
                  <a href="#terms">Termos e Condições</a>
                </li>
                <li>
                  <a href="#privacy">Política de Privacidade</a>
                </li>
                <li>
                  <a href="#cookies">Política de Cookies</a>
                </li>
                <li>
                  <a href="#complaints">Livro de Reclamações</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2025 Kodly. Todos os direitos reservados.</p>
            <p>Desde 2015, a sua loja de confiança em tecnologia</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default ProductPage;
